/* eslint-env browser, jquery */

'use strict';

class DiscountView {
  constructor() {
    this.$discountSection = document.querySelectorAll('.deal-discount');

    this.$el = document.querySelectorAll('#discount-data, .discount-data');
    this.$discountValue = document.querySelectorAll(
      '#discount-value, .discount-value'
    );
    this.$discountPercent = document.querySelectorAll(
      '#discount-percent, .discount-percent'
    );
    this.$discountYouSave = document.querySelectorAll(
      '#discount-you-save, .discount-you-save'
    );

    return window.DealEventPipe.on('priceUpdate', priceData =>
      this.updateTiles(priceData)
    );
  }

  updateTiles({ value, percent, savings, hideOriginalPriceAndDiscount }) {
    this.$discountValue.forEach(el => (el.innerHTML = value));
    this.$discountPercent.forEach(el => (el.innerHTML = percent));
    this.$discountYouSave.forEach(el => (el.innerHTML = savings));

    this.$discountSection.forEach(
      el => (el.style.display = hideOriginalPriceAndDiscount ? 'none' : 'block')
    );
  }
}

module.exports = DiscountView;
